import React from 'react';

/**
 * True when a performance board is rendered as an approvals-screen sign-off board.
 * Sign-off boards of sub-period programmes aggregate their data by driver over the
 * parent period (see useAggregatedBonusDatasource) and switch the Bonus Reward
 * slideout sections into a total-plus-weekly-breakdown mode. Read by the grid and
 * the slideout sections; false everywhere else.
 */
interface SignOffBoardContextType {
  isSignOffBoard: boolean;
}

const SignOffBoardContext = React.createContext<SignOffBoardContextType>({
  isSignOffBoard: false,
});

export default SignOffBoardContext;
